module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","create":"Register my info","update":"Edit my info","edit":"Edit","apply":"Apply","reset":"Reset"}}')
  delete Component.options._Ctor
}
